<template>
  <div class="inFront">
    <div class="top extreme-left">
      <slot name="topextremeleft"></slot>
    </div>
    <div class="top extreme-right">
      <slot name="topextremeright"></slot>
    </div>
    <div class="top left">
      <slot name="topleft"></slot>
    </div>
    <div class="top center">
      <slot name="topcenter"></slot>
    </div>
    <div class="top right">
      <slot name="topright"></slot>
    </div>
    <div class="middle left">
      <slot name="centerleft"></slot>
    </div>
    <div class="middle right">
      <slot name="centerright"></slot>
    </div>
    <div class="bottom left">
      <slot name="bottomleft"></slot>
    </div>
    <div class="bottom center bottomCenter">
      <slot name="bottomcenter"></slot>
    </div>
    <div class="bottom right">
      <slot name="bottomright"></slot>
    </div>
    <div class="bottom right inContainer">
      <slot name="bottomrightincontainer"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.inFront > * {
  z-index: 1000;
  position: absolute;
}

.top {
  top: 0px;
  height: 11vh;
  display: flex;
}

.bottom {
  bottom: 0;
  height: 11vh;
  display: flex;
  align-items: center;
}
.bottom.left {
  z-index: 1002;
}
.bottom.center {
  z-index: 1001;
  left: 140px;
  right: 140px;
  width: auto;
  display: flex;
  justify-content: center;
}
.middle {
  /* top: 40%; */
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.middle > * {
  display: block;
}

.left {
  left: 7vw;
}

.middle.left {
  left: 0;
  width: 7vw;
}

.center {
  z-index: 900;
  right: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: grid;
  grid-auto-flow: column;
  padding: 0;
}

.right {
  right: 120px;
}

.middle.right {
  right: 0;
  width: 7vw;
}

.top.right {
  display: flex;
}

.extreme-left {
  left: 0;
  top: 0;
  width: 7vw;
  height: 11vh;
  display: flex;
}

.extreme-right {
  right: 0;
  top: 0;
  width: 7vw;
  height: 11vh;
  display: flex;
}

.bottom.inContainer {
  right: 8vw;
  bottom: 10vh;
  transform: translateY(50%);
}

.logo-bottom-right {
  width: 200px;
  margin-bottom: 55px;
}

@media only screen and (max-width: 1280px) {
  .logo-bottom-right {
    width: 160px;
    margin-bottom: 55px;
  }

  .left {
    left: 10vw;
  }

  .bottom.center {
    left: 5%;
    right: 5%;
  }
}
</style>
